export interface SalesOrder {
    id?: number;
    society_id?: number;
    client_id?: number;
    destination_id?: number;
    sector_id?: number;
    currency_id?: number;
    payment_condition_id?: number;
    payment_method_id?: number;
    contact_name?: string;
    contact_email?: string;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    // Campos del serializer All
    society_rut?: string;
    society?: string;
    client_rut?: string;
    client?: string;
    sector?: string;
    contact?: string;
    currency?: string;
    payment_condition?: string;
    payment_method?: string;
    days?: number | null;
    total_neto?: number | null;
}

export interface SalesOrderDataForm {
    id?: number;
    society_id?: number;
    client_id?: number;
    contact_id?: number;
    sector_id?: number;
    currency_id?: number;
    payment_condition_id?: number;
    payment_method_id?: number;
    contact_name?: string;
    contact_email?: string;
    days?: number;
    delivery_condition_id?: number;
    destination_id?: number;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    created_by_name?: string;
    updated_by_name?: string;

    // Uno o dos pagos
    number_of_payments?: number;
    payment_1_percentage?: number;
    payment_1_condition_id?: number;
    payment_1_condition_name?: string;
    payment_1_days?: number;
    payment_2_percentage?: number;
    payment_2_condition_id?: number;
    payment_2_condition_name?: string;
    payment_2_days?: number;
}

export const defaultSalesOrderDataForm: SalesOrderDataForm = {
    society_id: undefined,
    client_id: undefined,
    sector_id: undefined,
    currency_id: undefined,
    payment_condition_id: undefined,
    payment_method_id: undefined,
    contact_name: '',
    contact_email: '',
    days: undefined,
    delivery_condition_id: undefined,
    destination_id: undefined,
    is_active: true,
    number_of_payments: 1
};

export interface SalesOrderFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    id?: string;
    society_id?: string;
    client_id?: string;
}

